import { render, staticRenderFns } from "./PerdasDeQualificacaoOscip.vue?vue&type=template&id=3236be51"
import script from "./PerdasDeQualificacaoOscip.vue?vue&type=script&lang=ts"
export * from "./PerdasDeQualificacaoOscip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports